import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { TRANSLATE_FILE_PATH } from './constants/AppConstants';

/**
 * Internationalisation
 * configuration for i18n
 */
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: TRANSLATE_FILE_PATH,
    },
    whitelist: [
      'en', 'de',
    ],
    fallbackLng: 'en',
    debug: true,
    interpolation: {
      escapeValue: false,
    },
  });
export default i18n;
